<template>
  <div>
    <div v-if="!data.type">
      <div class="grid-x">
        <div class="large-6 cell">
          <article class="dashboard_tile">
            <header>
              <span class="font_icon left fa fa-image fa-2x"></span>
              <h2>
                Image buyers
              </h2>
            </header>
            <div class="text">
              <ul>
                <li>Post a search</li>
                <li>Receive the images </li>
                <li>License an image</li>
              </ul>
              <p>
                <br />
                <button @click="handleClickBuyer">
                  Image buyers click here
                </button>
              </p>
            </div>
          </article>
        </div>
        <div class="large-6 cell">
          <article class="dashboard_tile">
            <header>
              <span class="font_icon left fa fa-camera fa-2x"></span>
              <h2>
                Photographers
              </h2>
            </header>
            <div class="text">
              <ul>
                <li>Receive the image request</li>
                <li>Upload an image</li>
                <li>Make a sale</li>
              </ul>
              <p>
                <br />
                <button @click="handleClickPhotographer">
                  Photographers click here
                </button>
              </p>
            </div>
          </article>
        </div>
      </div>
      <p>
        <br />
        Millennium's Interface is as simple as ABC
      </p>
    </div>

    <div v-if="isSaving">
      <h2>
        Registering please wait...
      </h2>
    </div>

    <div v-if="data.type == 'buyer' && isSaved">
      <h2>
        Thank you for registering as an Image Buyer
      </h2>
      <p>
        <br />
        <input type="submit" value="Click here to post a search" />
      </p>
    </div>

    <div v-if="data.type == 'photographer' && isInitial">
      <h2>
        Before registering as a Photographer
      </h2>
      <p>
      You need to submit a test high res file so that we can check the quality of your scans
      </p>
      <fieldset>
        <label></label>
        <article>
          <div v-if="data.image">
            <img :src="file.previewImage" style="width:auto;height:200px;" />
            <br />
            <button @click="handleClickRemoveImage">
              Remove image
            </button>
          </div>
          <interface-upload-box
            v-if="!data.image"
            doc-type="interface" 
            doc-group="group1"
            doc-file-types="image/jpeg"
            @select="handleSelect"
          />
          <div class="image_details">
            <div class="instructions">
              <p>
                When uploading an image please ensure that:
              </p>
              <ul>
                <li>
                  High res files should be uploaded as jpegs with a maximum compressed size of 10MBs and a minimum uncompressed size of 25MBs
                </li>
              </ul>
            </div>
          </div>
        </article>
      </fieldset>
      <p>
        <br />
        <button 
          @click="handleClickUpload"
          :disabled="!data.image"
        >
          Click here to upload and register
        </button>
      </p>
    </div>

    <div v-if="data.type == 'photographer' && isSaved">
      <h2>
        Thank you for registering as a Photographer
      </h2>
    </div>
  </div>
</template>

<script>
import InterfaceUploadBox from './InterfaceUploadBox.vue';

const STATE_INITIAL = 0,
  STATE_SAVING = 1,
  STATE_SAVED = 2,
  STATE_FAILED = 3; 

export default {
  name: 'InterfaceApplyForm',
  props: {
    isSignedIn: Boolean,
    myUrl: String,
  },
  components: {
    InterfaceUploadBox,
  },
  data: function(){
    return {
      currentState: null,
      data: {
        type: null,
        image: null,
        image_base64: null
      },
      file: null,
    }
  },
  computed: {
    isInitial: {
        get () {
            return this.currentState === STATE_INITIAL;
        },
    },
    isSaving: {
        get () {
            return this.currentState === STATE_SAVING;
        },
    },
    isSaved: {
        get () {
            return this.currentState === STATE_SAVED;
        },
    },
    isFailed: {
        get () {
            return this.currentState === STATE_FAILED;
        },
    },
    isValid: {
        get () {
            // return (this.data.reply_image_name !== null && this.data.reply_image_name !== '') 
            //   && (this.data.reply_photographer !== null && this.data.reply_photographer !== '') 
            //   && (this.data.reply_image !== null && this.data.reply_image !== '')
            //   && this.agreeToTerms;
        },
    },
  },
  created: function () {
    this.currentState = STATE_INITIAL;
  },
  methods: {
    handleClickBuyer() {
      console.log('handleClickBuyer');
      if(this.isSignedIn) {
        this.data.type = 'buyer';
        this.register();
      } else {
        window.location.replace(this.myUrl);
      }
    },
    handleClickPhotographer() {
      console.log('handleClickPhotographer');
      if(this.isSignedIn) {
        this.data.type = 'photographer';
      } else {
        window.location.replace(this.myUrl);
      }
    },
    handleClickUpload() {
      this.register();
    },
    handleClickRemoveImage() {
      this.file = null;
      this.data.image = null;
      this.data.image_base64 = null;
    },
    handleSelect(file) {
      this.file = file;
      this.data.image = file.name;
      this.data.image_base64 = file.previewImage;
    },
    register() {
      this.currentState = STATE_SAVING;
      const self = this;
      // console.log(this.data);
      // console.log(window.baseUrl);
      this.axios.post(window.baseUrl + 'index/register', this.data).then(response => {
        // console.log(response.data.responseResult.data);
        console.log(response.data.responseResult);
        // self.notes = response.data.responseResult.data;
        self.onRegisterComplete();
      });
    },
    onRegisterComplete() {
      const self = this;
      this.currentState = STATE_SAVED;
      // Set redirect 
      setTimeout(function(){ 
          // window.location.replace(window.baseUrl + 'requests');
      }, 50);
    },
  }
}
</script>
